export default __webpack_public_path__ + "static/portfolio_gallery_30-d38894df73c200104d48ba4a3e38483b.jpg";